// @flow

const TeamPrivacyConstants = {
  VISIBLE: "VISIBLE",
  SECRET: "SECRET",
};

export default TeamPrivacyConstants;
